<template lang="pug">
  #footer-wrapper
    .container.footer
      .row.justify-content-center
        .col-12.col-md-6.d-flex.text-center
          p.mb-0.mr-2.text-center Desarrollado con el apoyo de:
          img.footer-img.mr-2.text-center(src="/assets/ceav.svg")
          img.footer-img.text-center(src="/assets/mex-gob.svg")
    
</template>

<script>
export default {
    name: "footer-wrapper"
}
</script>

<style lang="scss">
#footer-wrapper {
  background-color: #13322b;
    .footer {       
        color: #fff;
        font-size: 0.8rem;
        padding: 20px;
        font-weight: 600;
        align-items: center;
        line-height: 2.5;
    }
    .footer-img {
        max-width: 100%;
        height: auto;
    }
}
@media (max-width: 767px) {
  #footer-wrapper {
    .footer {
      line-height: 1.5;
    }
  }
}

</style>
